import consentthing from "@/components/consentDeclaration/consentDeclarationCard.vue"
import userService from "@/services/userService"
export default [
  {
    path: "/",
    name: "Home",
    meta: {
      navbarTitle: "roody",
      fullWidth: true,
      backgroundColor: "#212121",
    },
    component: () => import("@/views/HomeNew_new.vue"),
    /*  // Hier prüfen wir jetzt sauber über den Service
      const userEmail = userService.getEmail()

      const isAdminUser = userEmail === "dominic.ammann.ch@gmail.com" || userEmail === "sebs@wellcomefit.ch"

      return isAdminUser ? import("@/views/HomeNew_new.vue") : import("@/views/HomeNew_new.vue")
    */
    children: [
      {
        path: "select-employee",
        name: "selectEmployee",
        meta: {
          navbarTitle: "Mitarbeiter Auswahl",
          fullWidth: true,
          backgroundColor: "#212121",
          hideBottomNavigation: true, // Versteckt die untere Navigation
          // Hier kannst du weitere Meta-Tags hinzufügen
        },
        // Lädt die Dialog-Komponente als Seiteninhalt
        component: () => import("@/components/employee/employeeSelectionDialog.vue"),
      },
    ],
  },

  {
    name: "planningDashboard",
    path: "/plen",
    meta: { hideBottomNavigation: true, backgroundColor: "#121212", hideAppBar: false, fullWidth: true },

    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/planning/PlanningMain.vue"),
  },

  {
    name: "employeeCourses",
    path: "/employee-courses", // WICHTIG: Route heisst 'party' wie gewünscht
    component: () => import("@/views/gf/employee/EmployeeCoursesRegistration.vue"),
    meta: { hideBottomNavigation: true, backgroundColor: "#121212", hideAppBar: false, fullWidth: true },
  },

  {
    name: "employeeCoursesAdmin",
    path: "/employee-courses/admin", // WICHTIG: Route heisst 'party' wie gewünscht
    component: () => import("@/views/gf/employee/EmployeeCoursesAdmin.vue"),
    meta: { hideBottomNavigation: true, backgroundColor: "#121212", hideAppBar: false, fullWidth: true },
  },

  {
    name: "hyroxScore",
    path: "/hyrox-score", // WICHTIG: Route heisst 'party' wie gewünscht
    component: () => import("@/views/hyrox/score/HyroxScoreRegistration.vue"),
    meta: {
      hideBottomNavigation: true,
      backgroundColor: "#212121",
      fullWidth: true,
      needsLoader: false,
      navbarTitle: "HYROX SCORE",
      hideLogo: true,
    }, // Rechte anpassen falls nötig
  },
  // --- AKADEMIE MODUL START ---
  {
    path: "/akademie",
    name: "akademie",
    meta: { hideBottomNavigation: true, hideAppBar: true, backgroundColor: "#121212", fullWidth: true },
    component: () => import("@/views/akademie/AkademieMain.vue"),
    redirect: "/akademie/suite",
    children: [
      {
        path: "suite",
        name: "akademieSuite",
        meta: { hideBottomNavigation: true, hideAppBar: true, backgroundColor: "#121212", fullWidth: true },
        component: () => import("@/views/akademie/LearningSuite.vue"),
      },
      {
        path: "kreativwerkstatt",
        name: "akademieKreativ",
        meta: { hideBottomNavigation: true, hideAppBar: true, backgroundColor: "#121212", fullWidth: true },
        component: () => import("@/views/akademie/Kreativwerkstatt.vue"),
      },
      {
        path: "schulungen",
        name: "akademieSchulungen",
        meta: { hideBottomNavigation: true, hideAppBar: true, backgroundColor: "#121212", fullWidth: true },
        component: () => import("@/views/akademie/Schulungsplan.vue"),
      },
    ],
  },
  {
    path: "/akademie-teacher",
    name: "akademieTeacherDashboard",
    meta: { hideBottomNavigation: true, hideAppBar: true, backgroundColor: "#121212", fullWidth: true, rights: ["aka_teacher", "aka_manage"] },
    component: () => import("@/views/akademie/teacher/TeacherDashboard.vue"),
  },

  {
    path: "/akademie/modules/:id",
    name: "akademieModuleDetail",
    meta: { hideBottomNavigation: true, hideAppBar: true, backgroundColor: "#121212", fullWidth: true },
    component: () => import("@/views/akademie/ModuleDetail.vue"),
  },
  {
    path: "/akademie/modules/:id/lessons/:lessonId",
    name: "akademieLessonPlayer",
    meta: { hideBottomNavigation: true, hideAppBar: true, backgroundColor: "#121212", fullWidth: true },
    component: () => import("@/views/akademie/LessonPlayer.vue"),
  },
  {
    path: "/akademie/modules/:id/quiz",
    name: "akademieQuizPlayer",
    meta: { hideBottomNavigation: true, hideAppBar: true, backgroundColor: "#121212", fullWidth: true },
    component: () => import("@/views/akademie/QuizPlayer.vue"),
  },
  {
    path: "/akademie/schulungen/:id",
    name: "akademieSchulungDetail",
    meta: { hideBottomNavigation: true, hideAppBar: true, backgroundColor: "#121212", fullWidth: true },
    component: () => import("@/views/akademie/SchulungDetail.vue"),
  },
  {
    path: "/akademie/kreativwerkstatt/:id",
    name: "akademieKreativBoard",
    meta: { hideBottomNavigation: true, hideAppBar: true, backgroundColor: "#121212", fullWidth: true },
    component: () => import("@/views/akademie/KreativBoard.vue"),
  },
  {
    path: "/akademie-admin",
    name: "akademieAdmin",
    meta: { hideBottomNavigation: true, hideAppBar: true, backgroundColor: "#121212", fullWidth: true, rights: ["aka_manage"] },
    component: () => import("@/views/akademie/admin/AkademieAdmin.vue"),
  },
  {
    path: "/akademie-teacher/user/:id",
    name: "akademieTeacherUser",
    meta: { hideBottomNavigation: true, hideAppBar: true, backgroundColor: "#121212", fullWidth: true, rights: ["aka_teacher", "aka_manage"] },
    component: () => import("@/views/akademie/teacher/UserKartei.vue"),
  },
  // --- AKADEMIE MODUL ENDE ---

  {
    name: "workCalendar",
    path: "/work-calendar",
    meta: { hideBottomNavigation: true, backgroundColor: "#121212", hideAppBar: true, fullWidth: true },
    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/workCalendar/workCalendar.vue"),
  },
  {
    path: "/panel",
    name: "employeePanel",
    meta: { hideBottomNavigation: true, hideAppBar: true, fullWidth: true },
    component: () => import("@/views/employee/employeePanel.vue"),
    children: [
      {
        path: "membercard",
        name: "MembercardView",
        meta: { hideBottomNavigation: true },
        component: () => import("@/views/employee/MembercardView.vue"),
      },
    ],
  },
  {
    path: "*",
    name: "catchAll",
    meta: { backgroundColor: "#212121" },
    component: () => import(/* webpackChunkName: "HomeNew.vue" */ "@/views/HomeNew_new.vue"),
  },
  { path: "/consent", name: "consent", component: consentthing },
  {
    path: "/forgot",
    name: "Forgot",
    component: () => import("@/views/launchScreen/launchScreen.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: { hideAppBar: true },
    component: () => import("@/views/launchScreen/launchScreen.vue"),
  },
  {
    path: "/register",
    name: "Registrieren",
    component: () => import("@/views/launchScreen/launchScreen.vue"),
  },
]
